import axios, { config } from '..';
import { RELEASE_SUCCESS, RELEASE_FAILED } from '../../actionTypes';

export default (id) => async (dispatch) => {
  try {
    const response = await axios.put(
      `/providers/sets/${id}/set-live`,
      {},
      config
    );

    const {
      data: { message, data },
    } = response;
    dispatch({
      type: RELEASE_SUCCESS,
      message,
      results: data,
    });
  } catch (err) {
    let error = {};
    if (err.response) {
      const {
        data: { status, message },
      } = err.response;
      error = { status, message };
    } else {
      error = {
        status: 500,
        message: err.message,
      };
    }
    dispatch({ type: RELEASE_FAILED, error });
  }
};
